import { render, staticRenderFns } from "./ProductCardSearch.vue?vue&type=template&id=1f5ece93"
import script from "./ProductCardSearch.vue?vue&type=script&lang=js"
export * from "./ProductCardSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports